import { useQuery } from '@tanstack/react-query';
import type { PublicMarketingStats } from '@lighthouse/shared';
import { api } from '../../services/api';
import { useCountUp, useInView } from '../../hooks/useInView';

function StatItem({
  label,
  value,
  suffix = '',
  active,
}: {
  label: string;
  value: number;
  suffix?: string;
  active: boolean;
}) {
  const display = useCountUp(value, active);
  return (
    <div className="live-stat">
      <p className="live-stat-value">
        {display.toLocaleString()}
        {suffix}
      </p>
      <p className="live-stat-label">{label}</p>
    </div>
  );
}

export function LiveStatsStrip() {
  const { ref, inView } = useInView(0.2);
  const { data, isLoading, isError } = useQuery({
    queryKey: ['marketing-stats'],
    queryFn: () => api.get<PublicMarketingStats>('/site/marketing-stats'),
    staleTime: 5 * 60_000,
  });

  return (
    <section className="live-stats-strip" aria-label="Platform highlights">
      <div ref={ref}>
        {isError ? null : isLoading || !data ? (
          <div className="live-stats-grid">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="live-stat live-stat--skeleton" />
            ))}
          </div>
        ) : (
          <div className={`live-stats-grid ${inView ? 'is-visible' : ''}`}>
            <StatItem label="Verified therapists" value={data.verifiedTherapists} active={inView} />
            <StatItem label="Sessions completed" value={data.completedSessions} active={inView} />
            <StatItem label="Wellness tools" value={data.wellnessActivities} active={inView} />
            <StatItem label="Learn articles" value={data.learnArticles} active={inView} />
          </div>
        )}
      </div>
    </section>
  );
}
